import React from 'react';
import styled from 'styled-components';

import DialogContent from '@webtv/components/dialog/dialog-content';
import Dialog, { Props as DialogProps } from '@webtv/components/dialog/dialog';

import { BRAND } from '@webtv/constants';

import CookieBannerDialogSection from './cookie-banner-dialog-section';
import CookieBannerDialogSectionItem from './cookie-banner-dialog-section-item';

interface CookieInformation {
  company: string;
  purpose: string;
  privacy: string;
  expiration: string;
  name: string;
  provider: string;
}

const COOKIES_INFORMATION: CookieInformation[] = [
  {
    company: 'Google Analytics',
    purpose:
      'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
    privacy: 'https://policies.google.com/technologies/partner-sites?hl=en',
    expiration: 'to år',
    name: '_ga',
    provider: BRAND === 'STOFA' ? 'stofa.dk' : 'norlysplay.dk'
  },
  {
    company: 'Google Analytics',
    purpose:
      'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
    privacy: 'https://policies.google.com/technologies/partner-sites?hl=en',
    expiration: 'et minut',
    name: '_gat',
    provider: BRAND === 'STOFA' ? 'stofa.dk' : 'norlysplay.dk'
  },
  {
    company: 'Google Analytics',
    purpose:
      'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
    privacy: 'https://policies.google.com/technologies/partner-sites?hl=en',
    expiration: 'en dag',
    name: '_gid',
    provider: BRAND === 'STOFA' ? 'stofa.dk' : 'norlysplay.dk'
  },
  {
    company: 'Hotjar',
    purpose:
      'Indsamler oplysninger om brugerne og deres aktivitet på websitet gennem indlejrede elementer med det formål at analysere og rapportere.',
    privacy: 'https://www.hotjar.com/legal/policies/privacy',
    expiration: 'et år',
    name: '_hjid',
    provider: BRAND === 'STOFA' ? 'stofa.dk' : 'norlysplay.dk'
  },
  {
    company: 'Hotjar',
    purpose:
      'Indsamler oplysninger om brugerne og deres aktivitet på websitet gennem indlejrede elementer med det formål at analysere og rapportere.',
    privacy: 'https://www.hotjar.com/legal/policies/privacy',
    expiration: 'et år',
    name: '_hjTLDTest',
    provider: BRAND === 'STOFA' ? 'stofa.dk' : 'norlysplay.dk'
  }
];

export const headerMapper = {
  company: 'Databehandler',
  purpose: 'Formål',
  privacy: 'Privatlivspolitik',
  expiration: 'Udløb',
  name: 'Navn',
  provider: 'Udbyder'
};

const CookieBannerDialogContent = styled(DialogContent)`
  padding: ${(props) => props.theme.spacing(10)};
`;

interface Props extends Omit<DialogProps, 'children'> {}

export const CookieBannerDialog: React.FC<Props> = (props: Props) => {
  return (
    <Dialog maxWidth="lg" {...props}>
      <CookieBannerDialogContent>
        {COOKIES_INFORMATION.map((section, index) => (
          <CookieBannerDialogSection key={index}>
            {Object.keys(section).map((sectionItem, index) => (
              <CookieBannerDialogSectionItem
                key={index}
                content={section[sectionItem as keyof CookieInformation]}
                header={headerMapper[sectionItem as keyof CookieInformation]}
              />
            ))}
          </CookieBannerDialogSection>
        ))}
      </CookieBannerDialogContent>
    </Dialog>
  );
};

export default React.memo(CookieBannerDialog);
